import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { formatDate } from "../lib/labels";

export function RejectionWarning({ matches, testid = "rejection-warning" }) {
  if (!matches?.length) return null;
  return (
    <div className="rounded-xl border-2 border-red-400 bg-red-50 p-4 text-sm text-red-900 space-y-2" role="alert" data-testid={testid}>
      <p className="font-bold inline-flex items-center gap-2"><AlertTriangle className="h-5 w-5 text-red-600" />Peringatan: cocok dengan {matches.length} data yang ditolak/dinonaktifkan atau masuk Daftar Hitam</p>
      <ul className="space-y-1.5">
        {matches.map((m) => (
          <li key={`${m.source}-${m.id}`} className={`break-words ${m.blocking ? "rounded-lg bg-red-600 text-white p-2" : ""}`} data-testid={`${testid}-item-${m.id}`}>
            {m.blocking && <span className="block font-extrabold uppercase tracking-wide">Jangan diproses</span>}
            <b>{m.sourceLabel}</b>: <Link to={m.link} className="underline font-semibold">{m.number ? `${m.number} · ` : ""}{m.name}</Link>
            {" — "}{m.matchedOn.join(", ")}{m.at ? ` · ${formatDate(m.at)}` : ""}
            {m.reason && <span className={`block text-xs ${m.blocking ? "text-red-50" : "text-red-800"}`}>Alasan{m.blocking ? "" : " sebelumnya"}: {m.reason}</span>}
          </li>
        ))}
      </ul>
      <p className="text-xs text-red-800">{matches.some((m) => m.blocking)
        ? "Masuk Daftar Hitam: tidak dapat ditindaklanjuti, disetujui, dijadikan lahan, atau diverifikasi selama entri aktif. Tolak / minta perbaikan, atau nonaktifkan entri di menu Daftar Hitam."
        : "Ini hanya peringatan otomatis. Periksa ulang sebelum memproses; keputusan tetap di tangan PT SJI."}</p>
    </div>
  );
}

export const isBlocked = (matches) => !!matches?.some((m) => m.blocking);
export const BLOCK_TIP = "Terkunci: data masuk Daftar Hitam. Nonaktifkan entri di menu Daftar Hitam bila ingin memproses.";
export const BlockNote = ({ matches, testid }) => (isBlocked(matches) ? (
  <p className="w-full text-xs font-semibold text-red-700 inline-flex items-center gap-1" data-testid={testid}><AlertTriangle className="h-3.5 w-3.5" />{BLOCK_TIP}</p>) : null);

export const RejectionBadge = ({ matches, testid }) => (matches?.length ? (
  <span className="inline-flex shrink-0 whitespace-nowrap items-center gap-1 rounded-full bg-red-600 text-white text-[10px] font-bold px-2 py-0.5" title={matches.map((m) => `${m.sourceLabel}: ${m.name} (${m.matchedOn.join(", ")})`).join("\n")} data-testid={testid}>
    <AlertTriangle className="h-3 w-3" />{matches.some((m) => m.blocking) ? "Daftar Hitam" : "Pernah ditolak"}
  </span>) : null);
